import type { AddressVM } from "@/types/application";

export enum ApplicantTypes {
  PRIMARY_APPLICANT = 1,
  CO_APPLICANT = 2,
  STUDENT = 3,
}

export class ApplicantTypeIds {
  public static get PRIMARY_APPLICANT(): number {
    return ApplicantTypes.PRIMARY_APPLICANT;
  }

  public static get CO_APPLICANT(): number {
    return ApplicantTypes.CO_APPLICANT;
  }

  public static get STUDENT(): number {
    return ApplicantTypes.STUDENT;
  }
}

export const PersonTypes: Readonly<Record<string, number>> = {
  ["Primary Applicant"]: ApplicantTypeIds.PRIMARY_APPLICANT,
  ["Co-Applicant"]: ApplicantTypeIds.CO_APPLICANT,
  ["Student"]: ApplicantTypeIds.STUDENT,
};


export interface ApplicantAddress {
  id: number;
  addressId?: number;
  applicantId: number;
  address1: string;
  address2: string | null;
  addressTypeId: number;
  addressTypeName: string;
  addressUnitTypeId: number | null;
  addressUnitTypeName: string | null;
  city: string;
  stateId: number;
  stateName: string;
  postalCode: string;
  countryId: number;
  countryName: string;
}

export interface AddressDictionary {
  [index: number]: Array<ApplicantAddress>;
}

export interface ApplicantSlimVM {
  id: number;
  fullName: string;
  userId: string;
  applicantTypeName: string;
  isSelected: boolean;
}

export interface ApplicantVM {
  id: number;
  fullName: string;
  initials: string;
  applicantTypeId: number;
  applicantTypeName: string;
  nationalIdNumberTypeId: number;
  nationalIdNumber: string;
  nationalIdLabel: string;
  birthday: string;
  addressDisplay: string;
  phoneDisplay: string;
  emailAddress: string;
  userId: string;
  username: string;
  selected: boolean; // FE-only
	loading: boolean; // FE-only
}

export interface ApplicantTabVM {
  address: AddressVM;
  addressDisplay: string;
  applicantTypeId: number;
  applicantTypeName: string;
  birthday: string; // Month DD, YYYY format
  citizenshipStatusId: number;
  citizenshipStatusName: string;
  consents: any[];
}

export interface ApplicantRequest {
  id: number;
  firstName: string;
  middleName: string;
  lastName: string;
  emailAddress: string;
  userId: string;
  nationalIdNumberTypeId: number;
  nationalIdNumber: string;
  citizenshipStatusId: number;
  dateOfBirth: string;
  phoneNumber: string;
  phoneNumberTypeId: number;
  address: AddressRequest;
}

export interface AddressRequest {
  addressId: number;
  addressTypeId: number;
	addressUnitTypeId: null | number;
  applicantId: number;
  address1: string;
  address2: string;
  city: string;
  stateId: number;
  postalCode: string;
  countryId: number;
}


export interface ApplicantFormVM extends ApplicantVM {
  firstName: string;
  lastName: string;
  middleName: string;
  citizenshipStatusId: number;
  citizenshipStatusName: string;
  dateOfBirth: any; //string | Date;
  address: AddressVM;
  phoneNumber: string;
  phoneNumberTypeId: number;
  phoneNumberTypeName: string;
  occupationName: string;
  occupationField: string;
  consents: ApplicantConsentVM[];
}

export interface ApplicantConsentVM {
  applicantId: number;
  name: string;
  description: string;
  consentGiven: boolean;
  createdAtUtc: string | null;
  status: string;
  statusCSSColor: string;
  dateConsented: string;
  sourceId: number;
  sourceName: string;
}

export interface VerifyApplicantNationalIdNumberRequest {
  nationalIdNumber: string;
  applicantId: number;
  applicationId: number;
}
